(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/common"), require("@angular/core"));
	else if(typeof define === 'function' && define.amd)
		define("angular2-voog-wysihtml", ["@angular/common", "@angular/core"], factory);
	else if(typeof exports === 'object')
		exports["angular2-voog-wysihtml"] = factory(require("@angular/common"), require("@angular/core"));
	else
		root["angular2-voog-wysihtml"] = factory(root["@angular/common"], root["@angular/core"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_1__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition